/// <amd-module name="SearchUI/Components/SearchResultItemComponent/index" />
export * from "SearchUI/Components/SearchResultItemComponent/SearchResultItemComponent";
export * from "SearchUI/Components/SearchResultItemComponent/SearchResultItemComponent.Props";